"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeRoute = exports.HomeRouteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var app_screen_layout_1 = require("../../app/app-screen-layout");
var tabs_1 = require("../../elements/tabs");
var tab_1 = require("../../elements/tab");
var use_app_routes_1 = require("../../../hooks/use-app-routes");
var use_lang_1 = require("../../../hooks/use-lang");
var following_route_1 = require("./following-route");
var my_profile_route_1 = require("./my-profile-route");
var entity_update_button_1 = require("../../entities/entity-update-button");
var current_path_name_1 = require("../../../utils/current-path-name");
var use_active_person_1 = require("../../../hooks/use-active-person");
var my_home_route_1 = require("./my-home-route");
var use_icons_1 = require("../../../hooks/use-icons");
var my_connections_route_1 = require("./my-connections-route");
var my_conversations_route_1 = require("./my-conversations-route");
var active_person_banner_1 = require("../../entities/active-person-banner");
var lodash_1 = require("lodash");
var my_wall_route_1 = require("./my-wall-route");
var entity_banner_1 = require("../../entities/entity-banner");
var menu_context_1 = require("../../context/menu-context");
var route_1 = require("../../../utils/route");
var use_entities_1 = require("../../../hooks/use-entities");
var router_1 = require("@reach/router");
var menu_button_1 = require("../../elements/menu-button");
/**
 * The Home Route wraps multiple other routes in sub-tabs
 */
var ROUTE_TITLES = {
  '': 'Home',
  home: 'Home',
  connections: 'My Connections',
  wall: 'My Wall',
  profile: 'My Profile'
};
exports.HomeRouteDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var TabStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 1px;\n  "], ["\n    margin-top: 1px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: 4px;\n  "], ["\n    margin-top: 4px;\n  "])))
});
var LatestStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ProfileStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var UpdateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-right: ", ";\n    display: flex;\n  "], ["\n    margin-right: ", ";\n    display: flex;\n  "])), theme_1.theme.UNIT(1.5)),
  desktop: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin: ", " ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    margin: ", " ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-semi-subtle'))
});
var SlimBannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    padding: ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-subtle'))
});
var MenuButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var TabsMenuStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Banner: (0, styled_components_1.default)(active_person_banner_1.ActivePersonBanner)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  SlimBanner: (0, styled_components_1.default)(entity_banner_1.EntityBanner)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), SlimBannerStyles),
  TabsMenu: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TabsMenuStyles),
  Tabs: (0, styled_components_1.default)(tabs_1.Tabs)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: (0, styled_components_1.default)(tab_1.Tab)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TabStyles),
  MenuButton: (0, styled_components_1.default)(menu_button_1.MenuButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  Following: (0, styled_components_1.default)(following_route_1.FollowingRoute)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), LatestStyles),
  Profile: (0, styled_components_1.default)(my_profile_route_1.MyProfileRoute)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ProfileStyles),
  UpdateButton: (0, styled_components_1.default)(entity_update_button_1.EntityUpdateButton)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), UpdateButtonStyles)
};
var HomeRoute = function (props) {
  var className = props.className,
    params = props.params,
    path = props.path;
  var from = (0, current_path_name_1.currentPathName)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  if (from === '/') {
    from = routes.homeReturn;
  }
  var entities = (0, use_entities_1.useEntities)();
  var Icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var activePerson = (0, use_active_person_1.useActivePerson)();
  var person = activePerson.person;
  var isProfile = path === routes.profile;
  var routePath = (0, lodash_1.trim)(path, '/');
  var bannerTitle = ROUTE_TITLES[routePath];
  var isHome = path === routes.home || path === routes.homeReturn;
  var items = [{
    to: routes.home,
    isCurrent: isHome,
    label: ROUTE_TITLES.home
  }, {
    to: routes.profile,
    isCurrent: path === routes.profile,
    label: ROUTE_TITLES.profile,
    icon: Icons.PersonCircle
  }, {
    to: routes.wall,
    isCurrent: path === routes.wall,
    label: ROUTE_TITLES.wall,
    icon: Icons.ChatLinesCircle
  }, {
    to: routes.connections,
    isCurrent: path === routes.connections,
    label: ROUTE_TITLES.connections,
    icon: Icons.AppSections.Connections
  }];
  var currentItem = items.find(function (item) {
    return item.isCurrent;
  });
  return react_1.default.createElement(app_screen_layout_1.AppScreenLayout, {
    className: className,
    header: react_1.default.createElement(My.TabsMenu, null, react_1.default.createElement(My.Tabs, {
      items: items.map(function (item) {
        return react_1.default.createElement(My.Tab, __assign({
          key: item.to
        }, item), t(item.label));
      })
    }), react_1.default.createElement(My.MenuButton, {
      hasMenu: items.length > 1,
      icon: currentItem.icon
    }, currentItem.label), react_1.default.createElement(My.UpdateButton, {
      iconSize: 18,
      useSpan: false,
      label: t('Edit Profile'),
      from: from,
      priority: "icon",
      entity: person,
      entityTypeName: "Profile"
    }))
  }, !(0, lodash_1.includes)(['/connections'], path) && react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      items: [{
        label: t('Edit Profile...'),
        onClick: function (event) {
          (0, router_1.navigate)((0, route_1.route)(entities.Profile.routes.update, {
            id: person && person.id,
            _trailing: "from".concat(from, "/")
          }));
        },
        value: "PROFILE",
        icon: react_1.default.createElement(Icons.Profile, null)
      }]
    }
  }, isHome ? react_1.default.createElement(My.Banner, {
    showMenu: true,
    alwaysShowIcon: false,
    title: bannerTitle
  }) : react_1.default.createElement(My.SlimBanner, {
    showMenu: true,
    title: bannerTitle || 'Person',
    size: "small",
    entity: person
  })), react_1.default.createElement(My.Container, {
    className: className
  }, isHome && react_1.default.createElement(my_home_route_1.MyHomeRoute, null), path === routes.wall && react_1.default.createElement(my_wall_route_1.MyWallRoute, null), path === routes.conversations && react_1.default.createElement(my_conversations_route_1.MyConversationsRoute, null), path === routes.following && react_1.default.createElement(following_route_1.FollowingRoute, null), isProfile && react_1.default.createElement(my_profile_route_1.MyProfileRoute, null), path === routes.connections && react_1.default.createElement(my_connections_route_1.MyConnectionsRoute, null)));
};
exports.HomeRoute = HomeRoute;
exports.HomeRoute.defaultProps = exports.HomeRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;